// src/api/axios.js
import axios from 'axios';

const BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:3000/api';

// Requests where a 401 is an expected outcome, not an expired session.
const AUTH_ENDPOINTS = ['/login', '/DocLogin', '/graph/login', '/signup'];

// Pages where a redirect to login would be pointless or a loop.
const PUBLIC_AUTH_PATHS = [
  '/login',
  '/doctorLogin',
  '/DocLogin',
  '/graph-login',
  '/signup',
  '/forgot-password',
  '/reset-password'
];

const instance = axios.create({
  baseURL: BASE_URL,
  withCredentials: true,
  timeout: 30000
});

instance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

instance.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error.response?.status;
    const requestUrl = error.config?.url || '';

    // A 401 from a login endpoint means wrong credentials, not an expired
    // session. Let the calling component show the error instead of logging out.
    const isAuthAttempt = AUTH_ENDPOINTS.some((endpoint) =>
      requestUrl.includes(endpoint)
    );

    if (status === 401 && !isAuthAttempt) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      localStorage.removeItem('userRole');

      const currentPath = window.location.pathname;
      const onPublicAuthPage = PUBLIC_AUTH_PATHS.some(
        (p) => currentPath.toLowerCase() === p.toLowerCase()
      );

      if (!onPublicAuthPage) {
        window.location.href = '/login';
      }
    }

    // Rate limited — surface the server's message so the UI can say how long
    // to wait rather than falling back to a generic credentials error.
    if (status === 429) {
      error.isRateLimited = true;
      error.rateLimitMessage =
        error.response?.data?.error ||
        'Too many attempts. Please wait a few minutes and try again.';
    }

    return Promise.reject(error);
  }
);

export default instance;